import React from 'react';
import {
  ToggleButtonGroup,
  ToggleButton,
  Divider,
} from '@mui/material';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setUserStatus } from 'store/filter/filterSlice';
import { savedUserStatusSelector } from 'store/filter/filterSelector';
import type { UserStatusValuesType } from 'types/filtersType';
import useCheckMatchApplyedAndSavedFilters from 'utils/useCheckMatchApplyedAndSavedFilters';
import { setUserStatusToStorage } from 'utils/storageFiltersHelper';

import StyledToggleFields from './Toggle.styles';

const Toggle = () => {
  const dispatch = useAppDispatch();
  const savedUserStatus = useAppSelector(savedUserStatusSelector);

  const checkMatchApplyedAndSavedFilters = useCheckMatchApplyedAndSavedFilters();

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newStatus: UserStatusValuesType,
  ) => {
    const value = !['active', 'dropped'].includes(newStatus) ? null : newStatus;
    dispatch(setUserStatus({ value }));
    setUserStatusToStorage({ value });
    checkMatchApplyedAndSavedFilters();
  };

  return (
    <StyledToggleFields>
      <Divider />
      <h3 className="filter-section__title">User Filters</h3>
      <h3>Status</h3>
      <ToggleButtonGroup
        color="primary"
        value={savedUserStatus === null ? 'all' : savedUserStatus}
        exclusive
        onChange={handleChange}
        aria-label="User status"
        fullWidth
        sx={{ width: '100%' }}
      >
        <ToggleButton value="all">ALL</ToggleButton>
        <ToggleButton value="active">ACTIVE</ToggleButton>
        <ToggleButton value="dropped">NON ACTIVE</ToggleButton>
      </ToggleButtonGroup>
    </StyledToggleFields>
  );
};

export default Toggle;
